import React from "react";

import { validateRequired, validateEmail } from "Utils/Validations";

import { SIFormField } from "Common/forms";
import { Row } from "Common/Grid";

const EditEmployeeEmailForm = () => (
  <div>
    <Row>
      <SIFormField name="employee[email]" label="Email Address" type="email" validate={[validateEmail, validateRequired]} />
    </Row>
  </div>
);

export default EditEmployeeEmailForm;
